import slugify from "slugify";
import { uploadFile } from "../../../../utils/storage";
import { getFileUrl } from "../../../../utils/api";
import uuidGenerator from "../../../../utils/uuidGenerator";
import VideoSnapshot from "video-snapshot";

export const videoFileHandler = async (file, orgId, activityId, changeFileHandler, setFileLoader) => {
  const extFile = file.name.split(".").pop().toLowerCase();

  if (extFile !== "mp4") {
    alert("Not a valid video file");
    return;
  }

  const sanitizeFileName = (name) => {
    return name.replace(/\s+/g, "_").replace(/[^\w.-]/g, "");
  };

  setFileLoader(true);

  // Sanitize file name for Azure
  const sanitizedFileName = sanitizeFileName(`${Date.now()}_${slugify(file.name, { lower: true })}`);
  const fileWithUniqueName = new File([file], sanitizedFileName, {
    type: file.type,
    lastModified: file.lastModified,
  });

  // Take snapshot
  const snapshoter = new VideoSnapshot(file);
  const previewSrc = await snapshoter.takeSnapshot();

  // Get video duration
  const video = document.createElement("video");
  video.preload = "metadata";
  video.src = URL.createObjectURL(file);

  video.onloadedmetadata = () => {
    URL.revokeObjectURL(video.src);
    const fileDuration = video.duration;

    fetch(previewSrc)
      .then((res) => res.blob())
      .then((blob) => {
        const previewFile = new File([blob], uuidGenerator() + ".png", {
          type: "image/png",
        });

        getFileUrl(orgId, activityId, previewFile.name)
          .then((data) => {
            uploadFile(previewFile, data.url + data.sas_token);
            return data.url;
          })
          .then((thumbnailUrl) => {
            // Upload main video
            getFileUrl(orgId, activityId, fileWithUniqueName.name).then((data) => {
              uploadFile(fileWithUniqueName, data.url + data.sas_token).then(() => {
                changeFileHandler({
                  hasFile: true,
                  name: file.name, // Keep original for UI
                  duration: Math.round(fileDuration),
                  thumbnailUrl: thumbnailUrl,
                  url: data.url,
                });

                setFileLoader(false);
              });
            });
          });
      });
  };
};
